<kfm-card [cardTitle]="cardTitle()" [cardIcon]="cardIcon()">
  @if (!isAppointment()) {
    <hs-form-field>
      <hs-form-label>{{ documentNumberLabel }}</hs-form-label>
      <input
        hsInput
        [placeholder]="documentNumberLabel"
        [disabled]="true"
        [value]="number()"
      />
    </hs-form-field>
  }

  <hs-form-field>
    <hs-form-label>{{ nameLabel }}</hs-form-label>
    <input
      hsInput
      [placeholder]="nameLabel"
      [value]="title()"
      [disabled]="!isEditable()"
      (change)="onTitleChanged($event.target.value)"
    />
  </hs-form-field>

  <hs-form-field>
    <hs-form-label>{{ descriptionLabel }}</hs-form-label>
    <textarea
      #descTextarea
      hsInput
      class="min-h-25"
      [placeholder]="descriptionLabel"
      [disabled]="!isEditable()"
      (change)="onDescriptionChanged(descTextarea.value)"
    ></textarea>
  </hs-form-field>

  @if (isInvoice()) {
    <hs-form-field>
      <hs-form-label>{{ paymentMethodLabel }}</hs-form-label>
      <hs-select
        [options]="paymentTerms()"
        [selectedValue]="selectedPaymentTerm()"
        [disabled]="!isEditable()"
        (selectionChanged)="onPaymentTermChanged($event)"
        [defaultText]="chooseSalesPaymentTermLabel"
      ></hs-select>
    </hs-form-field>
  }

  <div class="flex flex-row gap-4 justify-end">
    <div class="text-sm italic">{{ createdAt() }}</div>
    <div class="text-sm italic">{{ lastEdited() }}</div>
  </div>
</kfm-card>
